/**
 * Casanuva Search — V2 Redesign
 * Dropdown panel with predictive search, recent searches, trending.
 */
/* Alle paden hieronder gaan door WORTEL. Zonder dat begint een zoekactie op
   casanuva.com/nl-nl met een sprong naar de Engelse hoofdmarkt, en haalt de
   suggestie-API haar prijzen en teksten daar ook vandaan. */
var WORTEL = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/*$/, '/');

class CasanuvaSearch extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('#CasanuvaSearch');
    this.dim = this.querySelector('#CasanuvaSearch-Dim');
    this.input = this.querySelector('#CasanuvaSearch-Input');
    this.clearBtn = this.querySelector('#CasanuvaSearch-Clear');
    this.emptyState = this.querySelector('#CasanuvaSearch-EmptyState');
    this.resultsContainer = this.querySelector('#CasanuvaSearch-Results');
    this.noResults = this.querySelector('#CasanuvaSearch-NoResults');
    this.noResultsTerm = this.querySelector('#CasanuvaSearch-NoResultsTerm');
    this.loading = this.querySelector('#CasanuvaSearch-Loading');
    this.liveRegion = this.querySelector('#CasanuvaSearch-LiveRegion');
    this.recentContainer = this.querySelector('#CasanuvaSearch-Recent');
    this.recentChips = this.querySelector('#CasanuvaSearch-RecentChips');
    this.closeBtn = this.querySelector('#CasanuvaSearch-Close');

    this.cache = new Map();
    this.debounceTimer = null;
    this.RECENT_KEY = 'cnv_recent_searches';
    this.MAX_RECENT = 5;

    this.bindEvents();
  }

  bindEvents() {
    // Close on dim click
    this.dim.addEventListener('click', () => this.close());

    // Sluitknop -- de enige uitweg die je ziet staan.
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());

    // Escape key
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && this.isOpen()) this.close();
    });

    // Input
    this.input.addEventListener('input', () => {
      clearTimeout(this.debounceTimer);
      var query = this.input.value.trim();
      this.clearBtn.classList.toggle('is-visible', query.length > 0);

      if (query.length === 0) {
        this.showEmptyState();
        return;
      }

      this.debounceTimer = setTimeout(() => this.search(query), 300);
    });

    // Enter key — go to search page
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        var q = this.input.value.trim();
        if (q.length > 0) {
          this.saveRecent(q);
          window.location.href = WORTEL + 'search?q=' + encodeURIComponent(q);
        }
      }
    });

    // Clear
    this.clearBtn.addEventListener('click', () => {
      this.input.value = '';
      this.clearBtn.classList.remove('is-visible');
      this.showEmptyState();
      this.input.focus();
    });

    // Triggers
    document.querySelectorAll('[data-casanuva-search-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });
  }

  isOpen() {
    return this.overlay.classList.contains('is-active');
  }

  open() {
    this.overlay.classList.add('is-active');
    // Stond de pagina al op slot -- bijvoorbeeld omdat je vanuit de menulade
    // komt -- dan laten we dat slot met rust en raken we het bij het sluiten
    // ook niet aan. Anders staat de lade nog open terwijl de pagina erachter
    // weer scrollt.
    this.zelfOpSlot = document.body.style.position !== 'fixed';
    if (this.zelfOpSlot) this.zetVast();
    this.showEmptyState();
    this.renderRecent();
    setTimeout(() => this.input.focus(), 150);
  }

  close() {
    this.overlay.classList.remove('is-active');
    if (this.zelfOpSlot) this.laatLos();
    this.zelfOpSlot = false;
    this.input.value = '';
    this.clearBtn.classList.remove('is-visible');
  }

  // Het slot dat de lades gebruiken. Dat zit in casanuva-cart-drawer.js en dat
  // bestand laadt alleen bij cart_type 'drawer' -- vandaar de terugval, zodat
  // zoeken niet omvalt als iemand die instelling omzet.
  zetVast() {
    if (typeof casanuvaZetVast === 'function') { casanuvaZetVast(); return; }
    document.body.style.overflow = 'hidden';
  }

  laatLos() {
    if (typeof casanuvaLaatLos === 'function') { casanuvaLaatLos(); return; }
    document.body.style.overflow = '';
  }

  showEmptyState() {
    this.emptyState.style.display = '';
    this.resultsContainer.classList.remove('is-visible');
    this.noResults.classList.remove('is-visible');
    this.loading.classList.remove('is-visible');
  }

  // === RECENT SEARCHES ===
  getRecent() {
    try { return JSON.parse(localStorage.getItem(this.RECENT_KEY)) || []; } catch(e) { return []; }
  }

  saveRecent(query) {
    var items = this.getRecent().filter(q => q.toLowerCase() !== query.toLowerCase());
    items.unshift(query);
    if (items.length > this.MAX_RECENT) items = items.slice(0, this.MAX_RECENT);
    localStorage.setItem(this.RECENT_KEY, JSON.stringify(items));
  }

  removeRecent(query) {
    var items = this.getRecent().filter(q => q !== query);
    localStorage.setItem(this.RECENT_KEY, JSON.stringify(items));
    this.renderRecent();
  }

  renderRecent() {
    var items = this.getRecent();
    if (items.length === 0) {
      this.recentContainer.style.display = 'none';
      return;
    }
    this.recentContainer.style.display = '';
    var html = '';
    items.forEach(function(q) {
      html += '<a href="' + WORTEL + 'search?q=' + encodeURIComponent(q) + '" class="cnv-search__recent-chip">';
      html += '<svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>';
      html += this.escapeHtml(q);
      html += '<span class="cnv-search__recent-chip-x" data-remove="' + this.escapeHtml(q) + '">×</span>';
      html += '</a>';
    }.bind(this));
    this.recentChips.innerHTML = html;

    // Bind remove buttons
    this.recentChips.querySelectorAll('.cnv-search__recent-chip-x').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.removeRecent(btn.dataset.remove);
      }.bind(this));
    }.bind(this));
  }

  // === SEARCH ===
  async search(query) {
    if (this.cache.has(query)) {
      this.renderResults(this.cache.get(query), query);
      return;
    }

    this.emptyState.style.display = 'none';
    this.resultsContainer.classList.remove('is-visible');
    this.noResults.classList.remove('is-visible');
    this.loading.classList.add('is-visible');

    try {
      var response = await fetch(
        WORTEL + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,query&resources[limit]=6'
      );
      var data = await response.json();
      this.cache.set(query, data);
      if (this.input.value.trim() === query) {
        this.saveRecent(query);
        this.renderResults(data, query);
      }
    } catch (err) {
      console.error('Search error:', err);
      this.loading.classList.remove('is-visible');
    }
  }

  renderResults(data, query) {
    this.loading.classList.remove('is-visible');
    this.emptyState.style.display = 'none';

    var resources = data.resources.results;
    var products = resources.products || [];
    var collections = resources.collections || [];
    var queries = resources.queries || [];
    var totalCount = products.length + collections.length + queries.length;

    if (totalCount === 0) {
      this.resultsContainer.classList.remove('is-visible');
      this.noResults.classList.add('is-visible');
      this.noResultsTerm.textContent = query;
      this.liveRegion.textContent = 'No results found for ' + query;
      return;
    }

    this.noResults.classList.remove('is-visible');

    var html = '';

    // Left: suggestions + collections
    html += '<div class="cnv-search__results-left">';

    if (queries.length > 0) {
      html += '<div class="cnv-search__heading">Suggestions</div>';
      queries.forEach(function(q) {
        html += '<a href="' + WORTEL + 'search?q=' + encodeURIComponent(q.text) + '" class="cnv-search__suggestion">';
        html += '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';
        html += '<span>' + this.highlightMatch(q.text, query) + '</span>';
        html += '</a>';
      }.bind(this));
    }

    if (collections.length > 0) {
      html += '<div class="cnv-search__collections-mini">';
      html += '<div class="cnv-search__heading">Collections</div>';
      collections.forEach(function(col) {
        html += '<a href="' + col.url + '" class="cnv-search__collection-link">';
        html += '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>';
        html += this.escapeHtml(col.title);
        html += '</a>';
      }.bind(this));
      html += '</div>';
    }

    html += '</div>';

    // Right: products
    if (products.length > 0) {
      html += '<div class="cnv-search__results-right">';
      html += '<div class="cnv-search__heading">Products</div>';
      html += '<div class="cnv-search__products-grid">';
      products.forEach(function(product) {
        var imgSrc = product.image || '';
        var price = this.formatPrice(product.price);
        html += '<a href="' + product.url + '" class="cnv-search__product-card">';
        html += '<div class="cnv-search__product-image">';
        if (imgSrc) html += '<img src="' + imgSrc + '" alt="' + this.escapeHtml(product.title) + '" loading="lazy" width="300" height="300">';
        html += '</div>';
        html += '<div class="cnv-search__product-info">';
        html += '<div class="cnv-search__product-title">' + this.escapeHtml(product.title) + '</div>';
        html += '<div class="cnv-search__product-price">' + price + '</div>';
        html += '</div></a>';
      }.bind(this));
      html += '</div>';
      // Label uit locales; een lege vertaling is een geldige vertaling.
      var alles = (this.getAttribute('data-view-all') || '').replace('__q__', this.escapeHtml(query));
      html += '<div class="cnv-search__view-all"><a href="' + WORTEL + 'search?q=' + encodeURIComponent(query) + '">' + alles + '</a></div>';
      html += '</div>';
    }

    this.resultsContainer.innerHTML = html;
    this.resultsContainer.classList.add('is-visible');
    this.liveRegion.textContent = totalCount + ' results found for ' + query;
  }

  highlightMatch(text, query) {
    var escaped = this.escapeHtml(text);
    var queryEscaped = this.escapeHtml(query);
    var regex = new RegExp('(' + queryEscaped.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return escaped.replace(regex, '<mark>$1</mark>');
  }

  /** suggest.json geeft het bedrag in hele eenheden ("116.95"), niet in centen.
      De opmaak komt uit cnvGeld, dat hem van Liquid afkijkt — hier stond een
      vast euroteken, dat op elke niet-euromarkt de verkeerde valuta toonde. */
  formatPrice(price) {
    if (window.cnvGeld) return window.cnvGeld.opmaak(price);
    var num = parseFloat(price);
    return isNaN(num) ? price : num.toFixed(2);
  }

  escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
}

customElements.define('casanuva-search', CasanuvaSearch);
